import React, { useState } from 'react';
import { Button, message } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { useTenantBranding } from 'providers/Tenant/TenantBrandingProvider';

// Botón "Exportar PDF" de la carta Gantt. Genera el PDF en el navegador, solo al hacer
// clic (react-pdf se carga en ese momento para no pesar en la página).
export default function ExportarGanttPdfButton({ idOrder, order, tareas, especialistas }) {
  const { branding } = useTenantBranding();
  const [generando, setGenerando] = useState(false);
  const sinFechas = !tareas?.some((t) => t.planned_start && t.planned_end);

  const exportar = async () => {
    setGenerando(true);
    try {
      const [{ pdf }, { default: GanttPdfDocument }] = await Promise.all([
        import('@react-pdf/renderer'),
        import('./GanttPdfDocument'),
      ]);
      const blob = await pdf(
        <GanttPdfDocument
          tareas={tareas}
          especialistas={especialistas}
          fechaComprometida={order?.fecha_comprometida ?? null}
          titulo={`Carta Gantt · Orden de trabajo ${idOrder}`}
          cliente={order?.budget?.cliente?.name ?? ''}
          organizacion={branding?.organization ?? ''}
          colores={{ primary: branding?.primary_color, secondary: branding?.secondary_color }}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `carta-gantt-odt-${idOrder}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      message.error('No se pudo generar el PDF. Inténtalo de nuevo.');
    } finally {
      setGenerando(false);
    }
  };

  return (
    <Button icon={<FilePdfOutlined />} onClick={exportar} loading={generando} disabled={sinFechas}>
      Exportar PDF
    </Button>
  );
}
